import type { ButtonProps } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../shared/components/AppButton";
import { PlusIcon } from "../../../../../shared/icons/PlusIcon";
import styles from "../styles.module.css";

interface Props extends ButtonProps {
  onAdd?: () => void;
  isDisabled?: boolean;
}

export const AddButton: FC<Props> = ({ onAdd, isDisabled, ...props }) => {
  const { t } = useTranslation();
  return (
    <AppButton
      onClick={onAdd}
      buttonType={"text"}
      icon={<PlusIcon />}
      className={classNames(styles["add-button"], {
        [styles.disabled]: isDisabled,
      })}
      {...props}
    >
      {t("sidebar.add_button")}
    </AppButton>
  );
};
